import axios from 'axios';
import { Notification, MessageBox, Message, Loading } from 'element-ui';
import router from '@/router';
import store from "@/store";
import {commonConstant} from '@/utils/Constants';
import commonUtil from '@/utils/commonUtil';

// 统一axios实例
const requestService = axios.create({
  // 请求URL公共部分
  baseURL: process.env.BASE_API,
  // 超时
  timeout: 60000
});

// 公共函数
function commonRequestUse(config) {
  config.headers["Custom-Language"] = localStorage.getItem('language') ? localStorage.getItem('language') : 'zh-CN';
  config.headers.Authorization = commonUtil.getLoginToken();
  config.headers["Operation-Platform"] = 1;
  return config;
}
function hanldeRequestError(error) {
  Message.error('发送请求失败，请联系管理员！');
  return Promise.reject(error);
}
function commonResponseUse(response) {
  let data = response.data;// 数据
  let code = data.code;// 编码
  switch (code){
    case "200":// 正常返回数据
      return data;
    case "403":// 登录失效
      store.commit('logout');
    default:// 不正常时
      Message.error(data.msg);
      return Promise.reject(data);
  }
}
function hanldeResponseError(error) {
  Message.error('服务器繁忙，请稍候再试！');
  return Promise.reject(error);
}

// 请求拦截器
requestService.interceptors.request.use(commonRequestUse,hanldeRequestError);
// 响应拦截器
requestService.interceptors.response.use(commonResponseUse,hanldeResponseError);

// 电梯工厂请求
const elevatorFactoryAxios = axios.create({
  baseURL: process.env.ELEVATOR_FACTORY_API,
  timeout: 60000
});
elevatorFactoryAxios.interceptors.request.use(commonRequestUse,hanldeRequestError);
elevatorFactoryAxios.interceptors.response.use(commonResponseUse,hanldeResponseError);
requestService.elevatorFactoryAxios = elevatorFactoryAxios;

// 公用下载文件请求
const downloadAxios = axios.create({
  baseURL: process.env.BASE_API,
  responseType: 'blob',  // 统一设置 responseType 为 blob
});
downloadAxios.interceptors.request.use(commonRequestUse,hanldeRequestError);
downloadAxios.interceptors.response.use(res=>{
  // 返回json即错误请求
  let contentType = res.headers['content-type'];
  if(contentType && contentType.indexOf('application/json') != -1){
    // 使用FileReader把blob转json再处理
    let file = new FileReader();
    // 读取到数据后的处理事件
    file.onload= ()=>{
      let obj = JSON.parse(file.result);
      Message.error(obj.msg);
      if(obj.code == '403'){ // 登录失效
        store.commit('logout');
      }
    }
    // 读取提示信息
    let blob=res.data;
    file.readAsText(blob,'utf-8');
    return Promise.reject(res);
  }
  return res;
},hanldeResponseError);

requestService.downloadFile = (url,method,fileName,data) => {
  return downloadAxios({url,method,data})
        .then(res=>{
          let downloadFileName = fileName;
          let contentDisposition = res.headers['content-disposition'];
          let keyName = 'filename=';
          let downloadFileNameIndex = -1;
          if (contentDisposition && (downloadFileNameIndex = contentDisposition.indexOf(keyName)) !== -1) {
            downloadFileName = contentDisposition.substring(downloadFileNameIndex + keyName.length);
            downloadFileName = decodeURIComponent(downloadFileName);
          }
          // 创建a标签下载文件
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', downloadFileName); // 文件名
          link.click();
          window.URL.revokeObjectURL(url);// 释放URL对象所占内存
        })
        .catch(res => {
          return res;
        });
}

export default requestService;



// WEBPACK FOOTER //
// ./src/utils/request.js